//TODO - clean up pathway of updates for modeled financials once we have a stable version of this view

import React from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MaterialTable from 'material-table';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import AssessmentIcon from "@material-ui/icons/Assessment";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Financials from "views/Components/Financials.jsx"
import FinancialsAnalytics from "views/Components/FinancialsAnalytics.jsx"

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import axios from "axios";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { API_ROOT } from 'api-config';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

const tableStyle = require('../../assets/style/tableStyle.json');
var tableOptions = require('../../assets/style/tableOptions.json');
tableOptions = JSON.parse(JSON.stringify(tableOptions));
const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  filterLabel: {
    marginTop: "15px"
  },
  ...extendedFormsStyle
};

const insuranceTableDataLoading = [{
  id: 0, entity: 'loading...', percentPatients: 'loading...',
  percentBilled: 'loading...', percentRevenue: 'loading...',
  discountRate: 'loading...', revenueSkew: 'loading...'
}]

const patientsInfo = 'The percentage of patients in your practice who have the given insurance.'
const billedInfo = 'The percentage of bills in your practice (in dollars) that have gone to the given insurance.'
const revenueInfo = 'The percentage of revenue in your practice (in dollars) that came from the given insurance.'

const discountRateInfo = 'The discount rate is how much the insurance company discounts your bills to them. For example, ' +
  'if you bill $10,0000 to an insurer and they pay you $8,000, the discount rate is 20%.'
const revenueSkewInfo = 'The revenue skew is the percent of practice revenue coming from this insurer minus the percent ' +
  'of practice billing attributed to this insurer. A positive skew means this insurer is paying at a better than average ' +
  'rate for your practice. A negative skew means it is paying at a worse than average rate for your practice. The magnitude ' +
  'of the skew shows how good or bad the insurer is. An insurer with a skew of -2% is a little worse than average. An insurer ' +
  'with a skew of -25% is bad news. And an insurer with a skew of +25% is one you want to keep around, since it is  ' +
  'paying much better than your practice average.'

const tableExplanation = 'To learn more about the data in a column, place your mouse over the column header or tap ' +
  'on the column header.'

class ReactTables extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')

    this.state = {
      userId: userId,
      insuranceTableData: insuranceTableDataLoading,
      updateFinancialsDialogueOpen: false,
      financialsToEdit: '',
      allFinancials: '',
      financialsAnalytics: '',
      practiceFinancialsTotal: {},
      activeEntity: '',
      allowAddInsurance: false
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.getFinancials()
    this.getFinancialsAnalytics()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getFinancials() {
    this.setState({
      insuranceTableData: insuranceTableDataLoading,
      updateFinancialsDialogueOpen: false
    })

    axios.get(`${API_ROOT}/practiceSystem/financials/?userId=` + this.state.userId,
      {headers: getApiHeaders()})
      .then(res => this.setFinancials(res.data));
  }

  setFinancials(res) {
    if (this._isMounted) {
      const allFinancials = res
      if (Object.keys(res).length !== 0 && res[0].entity === 'self') {
        this.setState({
          practiceFinancialsTotal: res[0],
          allowAddInsurance: true
        })
        res.shift()
      }
      this.setState({
        insuranceTableData:  res.map((prop) => {
          return {
            id: prop.entityId,
            entity: prop.entity,
            percentPatients: prop.percentPatients + '%',
            percentBilled: prop.percentBilled + '%',
            percentRevenue: prop.percentRevenue + '%',
            discountRate: prop.discountRate + '%',
            revenueSkew: prop.revenueSkew + '%',
            actions: (
                    <div>
                      <span>
                      {/* use this button to add a edit kind of action */}
                        <Button
                          justIcon
                          round
                          simple
                          onClick={this.updateInsuranceDialogOpen.bind(this, prop.entity, prop)}
                          color="danger"
                          id={"updateInsuranceDialogButton_" + prop.id}
                          className="edit"
                        >
                        <Edit/>
                      </Button>{" "}
                      </span>
                    </div>
                  )
          }
        }),
        allFinancials: allFinancials
      });
    }
  }

  getFinancialsAnalytics() {
    axios.get(`${API_ROOT}/practiceSystem/financialsAnalytics/?userId=` + this.state.userId,
      {headers: getApiHeaders()})
      .then(res => this.setFinancialsAnalytics(res.data));
  }

  setFinancialsAnalytics(res) {
    if (this._isMounted) {
      this.setState({
        financialsAnalytics: res['entities']
      })
    }
  }

  updateFinancialsDisplay() {
    this.getFinancials()
    this.getFinancialsAnalytics()
  }

  updateInsuranceDialogOpen(entity, financials) {
    this.setState({
      updateFinancialsDialogueOpen: true,
      activeEntity: entity,
      financialsToEdit: financials
    })
  }

  updateInsuranceDialogueClose() {
    this.setState({
      updateFinancialsDialogueOpen: false
    })
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeSelect = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }




  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <Dialog
          open={this.state.updateFinancialsDialogueOpen}
          onClose={this.handleCloseFamilyDialogue}
          aria-labelledby="form-dialog-title"
          maxWidth='lg'
        >
          <DialogTitle id="form-dialog-title">
          <span  style={this.state.activeEntity === 'self' ? {} : { display: 'none' }}>
            whole practice financials
          </span>
          <span  style={this.state.activeEntity === '' ? {} : { display: 'none' }}>
            add financials for new insurance
          </span>
          <span  style={this.state.activeEntity === 'self' || this.state.activeEntity === '' ? { display: 'none' } : {}}>
            financials for {this.state.activeEntity}
          </span>
          </DialogTitle>
          <DialogContent id="userProfileDialogue">
            <Financials
              userId = {this.state.userId}
              financials = {this.state.financialsToEdit}
              entity = {this.state.activeEntity}
              onUpdate = {this.updateFinancialsDisplay.bind(this)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.updateInsuranceDialogueClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <GridItem xs={12}>
          <Card>
            <CardHeader color="cirrusBlue" icon>
              <CardIcon color="cirrusBlue">
                <AssessmentIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Practice assessment</h4>
            </CardHeader>
            <CardBody>


              <div className={classes.block}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button color="cirrusBlue"
                            onClick={this.updateInsuranceDialogOpen.bind(this, 'self', this.state.practiceFinancialsTotal)}
                            className={classes.updateProfileButton}
                            type="submit"
                            id="updatePracticeFinancials">
                      update practice financials
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button color="cirrusBlue"
                            onClick={this.updateInsuranceDialogOpen.bind(this, '')}
                            className={classes.updateProfileButton}
                            type="submit"
                            id="addNewInsurance"
                            disabled={!this.state.allowAddInsurance}
                    >
                      add new insurance
                    </Button>
                    <br />
                    <span xs={12} sm={12} md={4} style={this.state.allowAddInsurance ? { display: 'none' } : {}}>
                    Please enter practice information before adding insurance-specific information.
                  </span>
                  </GridItem>

                </GridContainer>
              </div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <MaterialTable
                    title=''
                    columns={[
                      { title: 'insurance', field: 'entity' },
                      { title: 'patients', field: 'percentPatients', align: 'center', tooltip: patientsInfo },
                      { title: 'billed', field: 'percentBilled', align: 'center', tooltip: billedInfo  },
                      { title: 'revenue', field: 'percentRevenue', align: 'center', tooltip: revenueInfo  },
                      { title: 'discount rate', field: 'discountRate', align: 'center', tooltip: discountRateInfo },
                      { title: 'revenue skew', field: 'revenueSkew', align: 'center', tooltip: revenueSkewInfo },
                      { title: '', field: 'actions', align: 'center' },
                    ]}
                    data={this.state.insuranceTableData}
                    style={tableStyle}
                    options={tableOptions}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  {tableExplanation}
                </GridItem>
              </GridContainer>

              <FinancialsAnalytics
                allFinancials = {this.state.financialsAnalytics}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

    );
  }
}

export default withStyles(styles)(ReactTables);
